const selectorStyles = {
  container: provided => ({
    ...provided,
    fontSize: 17,
    marginBottom: 23,
    zIndex: 'inherit',
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#19202d' : '#d7dfe7',
    '&:hover': {
      borderColor: '#19202d',
    },
    borderRadius: 3,
    borderBottomLeftRadius: state.menuIsOpen ? 0 : 3,
    borderBottomRightRadius: state.menuIsOpen ? 0 : 3,
    outline: 'none',
    boxShadow: 'none',
    height: 40,
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: 40,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: provided => ({
    ...provided,
    marginTop: 0,
    borderRadius: 3,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderColor: '#19202d',
    borderStyle: 'solid',
    borderWidth: 1,
    borderTopWidth: 0,
  }),
  menuList: provided => ({
    ...provided,
    display: 'flex',
    flexDirection: 'column',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f3f5fa' : '#fff',
    color: '#19202d',
    margin: 0,
    padding: '0px 16px',
    width: 'auto',
    border: 'none',
    borderBottom: '1px solid #d7dfe7',
    opacity: state.isDisabled ? 0.4 : 1,
    '&:last-child': { borderBottom: 'none' },
  }),
  placeholder: provided => ({
    ...provided,
    color: '#8ea3b5',
  }),
  valueContainer: provided => ({
    ...provided,
    height: 40,
  }),
};

const selectorProps = {
  styles: selectorStyles,
  classNamesPrefix: 'sel',
  noOptionMessage: () => 'no results',
  components: {
    IndicatorsContainer: () => null,
  },
};

export default selectorProps;
